export default __webpack_public_path__ + "static/media/ALIGN_LEFT_unpressed.8784cf35.svg";